<template>
<div>
    <kt-col xs="12" class="mb-5">
        <img :src="form_data.logo" style="max-width:300px" class="d-block m-auto">
    </kt-col>


    <form @submit.prevent="submit" id="gateway_form">
        <kt-form-section is_first>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="user_full_name">
                            {{ $t('label.User_full_name') }} {{' :'}}
                        </kt-form-label>
                        <router-link :to="'/users/'+ form_data.user.user_id +'/details'">
                            {{form_data.user.full_name}}
                        </router-link>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="8" md="8" xs="12">
                            <kt-form-group>
                                <kt-form-label for="merchant_type">
                                    {{ $t('label.merchant_type') }}
                                </kt-form-label>
                                <select
                                        id="merchant_type"
                                        name="merchant_type"
                                        v-model="form_data.merchant_type"
                                        class="form-control kt-selectpicker"
                                >
                                    <option value=0>
                                        {{ $t('label.real') }}
                                    </option>
                                    <option value=1>
                                        {{ $t('label.legal') }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="12" md="12" xs="12" v-if="form_data.merchant_type == 1">
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="com_name_fa">
                                    {{ $t('label.com_name_fa') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="com_name_fa"
                                        name="com_name_fa"
                                        v-model="form_data.com_name_fa"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="com_name_en">
                                    {{ $t('label.com_name_en') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="com_name_en"
                                        name="com_name_en"
                                        dir="ltr"
                                        v-model="form_data.com_name_en"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="national_legal_code">
                                    {{ $t('label.national_legal_code') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="national_legal_code"
                                        name="national_legal_code"
                                        v-model="form_data.national_legal_code"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="12" xs="6">
                            <kt-form-group>
                                <kt-form-label for="register_number">
                                    {{ $t('label.register_number') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="register_number"
                                        name="register_number"
                                        v-model="form_data.register_number"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="register_date">
                                    {{ $t('label.com_register_date') }}
                                </kt-form-label>
                                <datePicker
                                        color="#00c1a4"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        display-format="jDD jMMMM jYYYY"
                                        input-class="form-control"
                                        id="register_date"
                                        name="register_date"
                                        v-model="form_data.register_date" type="date" />
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="farsi_name">
                            {{ $t('label.farsi_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="farsi_name"
                                name="farsi_name"
                                v-model="form_data.farsi_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="english_name">
                            {{ $t('label.english_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="english_name"
                                name="english_name"
                                v-model="form_data.english_name"
                                dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="gateway_id">
                            {{ $t('label.gateway_id') }}
                        </kt-form-label>
                        <kt-form-control
                                id="gateway_id"
                                name="gateway_id"
                                v-model="form_data.gateway_id"
                                disabled
                                dir="rtl"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <div class="col-12">
                    <kt-form-group>
                        <kt-form-label for="subcategory_code">
                            {{ $t('label.subcategory_code') }}
                        </kt-form-label>
                        <select
                                id="subcategory_code"
                                name="subcategory_code"
                                v-model="form_data.subcategory_code"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="subcategory.key"
                                    v-for="subcategory in subcategories"
                                    :selected="form_data.subcategory_code == subcategory.key"
                                    :value="subcategory.key"
                            >
                                {{ subcategory.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </div>
            </kt-row>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="address">
                            {{ $t('label.address') }}
                        </kt-form-label>
                        <select
                                v-if="addresses"
                                id="address"
                                name="address"
                                v-model="form_data.address"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="address.id"
                                    v-for="address in addresses"
                                    :selected="form_data.address == address.id"
                                    :value="address.id"
                            >
                                {{ address.address }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="telephone">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="telephone"
                                name="telephone"
                                v-model="form_data.telephone"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="tax_payer_code">
                            {{ $t('label.tax_payer_code') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="tax_payer_code"
                                name="tax_payer_code"
                                v-model="form_data.tax_payer_code"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="sheba_number">
                            {{ $t('label.sheba_number') }}
                        </kt-form-label>
                        <select
                                id="sheba_number"
                                name="sheba_number"
                                v-model="form_data.sheba"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="index"
                                    v-for="(sheba_number, index) in iban_list"
                                    :selected="form_data.sheba == sheba_number.id"
                                    :value="sheba_number.id"
                            >
                                {{ sheba_number.number }} ({{shebaNumberShaparakStatusStr.get(sheba_number.status)}})
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>

        <kt-form-section>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="site_address">
                            {{ $t('label.site_address') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="site_address"
                                name="site_address"
                                placeholder="https://mysite.ir/"
                                v-model="form_data.site_address"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="server_ip">
                            {{ $t('label.server_ip') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="server_ip"
                                name="server_ip"
                                v-model="form_data.server_ip"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>

        <kt-form-action class="mt-4">
            <kt-button
                    class="m-2"
                    size="md"
                    variant="success"
                    type="submit"
                    v-bind:wide="true"
                    id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </form>
</div>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import $ from 'jquery'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'
import {shebaNumberShaparakStatusStr} from "@/constants/shebaNumberShaparakStatus";

export default {
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            subcategories: subcategories,
            'hashid': this.$route.params.hashid,
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 50,
                    value: this.$t('gateway.wages.half')
                }
            ]
        }
    },
    created() {
        this.afterDispatch()
        let params = {
            hashid: this.$route.params.hashid,
            shop_type: 1
        };
        this.$store.dispatch('shebaNumber/fetchIbanList', params)
    },
    methods: {
        afterDispatch() {
            setTimeout(function(){
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 1000);

            document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
        },
    },
    computed: {
        shebaNumberShaparakStatusStr() {
            return shebaNumberShaparakStatusStr
        },
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'iban_list'
        ])
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>